module.exports = __webpack_public_path__ + "54625a728c1e66273fabfe8e976fb12b.pdf";